<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Edit Export Attributes</h3>
    </div>

    <div class="items">
      <importer-export-attributes-form
        [entity]="item"
        [action]="action"
        (allValid)="validExportAttributes = $event"
        (allRequired)="requiredExportAttributes = $event"></importer-export-attributes-form>
    </div>

    <div class="buttons">
      <coin-v2-button
        [type]="'secondary'"
        [icon]="'close'"
        [text]="'Cancel'"
        [iconPos]="'right'"
        (click)="close()"></coin-v2-button>
      <coin-v2-button
        [type]="'primary'"
        [icon]="'save'"
        [text]="'Save'"
        [iconPos]="'right'"
        [disabled]="uploading || !validExportAttributes || !requiredExportAttributes"
        (click)="save()"></coin-v2-button>
    </div>

    @if (action === Action.Edit) {
      <div class="info-footer">
        <p [class.error]="!requiredExportAttributes">Fields marked with * are mandatory.</p>
      </div>
    }
  </div>
</div>
